import React, {FC, useEffect} from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import {MessageBanner} from '/component/base/MessageBanner/MessageBanner';
import {
  FAILED_TO_PROCESS_REQUEST_EXCEPTION,
  SERVER_IS_DOWN_EXCEPTION,
} from '/enum/errors.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {useStateWithPrevious} from '/util/hooks/useStateWithPrevious.hook';

import {styles} from './ApiError.style';
import {
  generateApiErrorAlertNavigateAway,
  generateErrorAlertTimeout,
} from './ApiErrorProvider.util';

interface ApiErrorProviderProps {
  currentScreen: string;
  currentScreenParams: any;
  isShowingServerIsDown: boolean;
  hideApiError: (params: {errorCode: string}) => void;
  children: React.ReactNode;
  isShowingFailedToProcessRequest: boolean;
}
export const ApiErrorProvider: FC<ApiErrorProviderProps> = ({
  currentScreen = '',
  currentScreenParams = {},
  isShowingServerIsDown = false,
  isShowingFailedToProcessRequest = false,
  hideApiError = noop,
  children = null,
}: ApiErrorProviderProps) => {
  const {ts} = useTranslation('apiErrorMessage');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    generateErrorAlertTimeout({
      hideApiError: () => hideApiError({errorCode: SERVER_IS_DOWN_EXCEPTION}),
      isShowingError: isShowingServerIsDown,
    }),
    [isShowingServerIsDown],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    generateErrorAlertTimeout({
      hideApiError: () =>
        hideApiError({errorCode: FAILED_TO_PROCESS_REQUEST_EXCEPTION}),
      isShowingError: isShowingFailedToProcessRequest,
    }),
    [isShowingFailedToProcessRequest],
  );

  const modalName = currentScreenParams?.modalName;

  const HIDE_REPORT_FAILED_ERROR_SCREENS = [
    'MANAGE_MY_SITE',
    'HEALTH_CARE_PROVIDER',
  ];

  const shouldHideReportFailedError =
    HIDE_REPORT_FAILED_ERROR_SCREENS.includes(modalName);

  // @ts-expect-error TS(2339): Property 'previous' does not exist on type '((newV... Remove this comment to see the full error message
  const [{previous: prevRouteName, value: currentRouteName}, setRouteName] =
    useStateWithPrevious(currentScreen);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    generateApiErrorAlertNavigateAway({
      currentRouteName,
      currentScreen,
      hideApiError,
      isShowingServerIsDown,
      prevRouteName,
      setRouteName,
    }),
    [currentScreen],
  );
  return (
    <>
      {children}
      {/* {isShowingServerIsDown ? ( */}
      {isShowingServerIsDown && !shouldHideReportFailedError ? (
        <View style={styles.messageBanner}>
          <MessageBanner
            bannerClose={() =>
              hideApiError({errorCode: SERVER_IS_DOWN_EXCEPTION})
            }
            message={ts('failedToLoad', 'Report failed to load')}
            alertLevel="error"
          />
        </View>
      ) : null}
      {isShowingFailedToProcessRequest ? (
        <View style={styles.messageBanner}>
          <MessageBanner
            style={{icon: styles.infoIcon, text: styles.messageText}}
            verticalBanner={true}
            alertLevel={'error'}
            iconName={'info'}
            message={ts(
              'failedToProcess',
              'Failed to process request please try again later.',
            )}
            bannerClose={() =>
              hideApiError({errorCode: FAILED_TO_PROCESS_REQUEST_EXCEPTION})
            }
          />
        </View>
      ) : null}
    </>
  );
};
